import Vue from 'vue'
import AmapVue from '@amap/amap-vue'
AmapVue.config.key = 'c0800ced1572fe200af2cf44e5035f8f'
AmapVue.loadPlugins("AMap.PolyEditor");
Vue.use(AmapVue)
